import { createContext } from "react";

const AuthContext = createContext({
  user: '',
  role: '',
  divisi: '',
  accessToken: '',
  onLogin: (params) => {},
  onLoginNoReload: (params) => {},
  onLogout: () => {},
});

export default AuthContext;